import { render, staticRenderFns } from "./manualAllocation.vue?vue&type=template&id=3d0f8329&scoped=true"
import script from "./manualAllocation.vue?vue&type=script&lang=js"
export * from "./manualAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0f8329",
  null
  
)

export default component.exports